import { createSlice } from "@reduxjs/toolkit";
import { act } from "react";

const pagesSlice = createSlice({
  name: "pages",
  initialState: {
    loadingData: true,
    sections: {},
    footer: {},
    archiveBlogPosts: {},
  },
  reducers: {
    setPageSections(state, action) {
      if (
        action.payload.apiSlug === "job" ||
        action.payload.apiSlug === "posts"
      ) {
        state.sections[action.payload.apiSlug + action.payload.endpoint] =
          action.payload;
      } else {
        state.sections[action.payload.apiSlug + action.payload.endpoint] =
          action.payload?.page_builder;
      }
      if (!Object.keys(state.footer).length) {
        state.footer = action.payload?.footer_data;
      }
      state.loadingData = false;
    },
    setLoadingData(state, action) {
      state.loadingData = action.payload;
    },
    setArchiveBlogPosts(state, action) {
      state.archiveBlogPosts = action.payload;
    },
  },
});

export const pagesActions = pagesSlice.actions;

export default pagesSlice;
